import script from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=e67c88c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e67c88c4"]])

export default __exports__